export const socialMediaManagementFaqs = [
  {
    question: "What does social media management include?",
    answer:
      "A typical organic social scope can include audience and channel priorities, a content plan, copywriting, design, scheduling, an agreed approval process and concise reporting. The exact platform mix, post volume, asset source and response responsibilities are confirmed before delivery begins.",
  },
  {
    question: "Which social media platforms do you manage?",
    answer:
      "We select platforms around the audience and commercial goal rather than promising activity everywhere. LinkedIn can suit many professional and technical services, while Instagram or Facebook may be more useful where visual work, communities or consumer discovery are important.",
  },
  {
    question: "Do you create the photos and video?",
    answer:
      "The base scope can use suitable client-supplied assets alongside agreed design and copy. On-site content capture, filming, extensive editing and photography are separately scoped so the delivery workload and usage permissions are clear.",
  },
  {
    question: "How is social media content approved?",
    answer:
      "We agree who supplies source material, who can approve content and how long approval normally takes. Content is shared through an agreed review route before scheduling, with responsibilities and revision limits recorded in the scope.",
  },
  {
    question: "Is paid social advertising included?",
    answer:
      "No, not by default. Organic content management and paid-social advertising are different scopes. Campaign strategy, audience setup, creative variants, landing pages, management fees and media spend are stated separately where paid activity is appropriate.",
  },
  {
    question: "Do you reply to comments and direct messages?",
    answer:
      "Routine monitoring or community management is included only when it is explicitly agreed. Daily inbox cover, customer-service responses, weekend monitoring and escalation handling require clear access, response rules and a separate workload allowance.",
  },
  {
    question: "How do you report on social media activity?",
    answer:
      "Reporting connects delivery and audience response to useful next decisions. Depending on the scope, that can include content published, relevant engagement, referral visits, enquiries, assisted conversations and what should be tested or changed next. We do not present reach alone as a business result.",
  },
  {
    question: "How much does social media management cost?",
    answer:
      "Investment depends on the number of platforms, post volume, source material, design and editing workload, approval process, community coverage and whether paid campaigns are involved. We confirm a defined scope and price after a short fit conversation rather than bundling unlimited delivery into an unclear retainer.",
  },
]
